// Page d'inscription — pensée comme une caisse (9 oct. 2026).
//
//   · en haut : la marque, le fil en trois étapes (Compte → Paiement →
//     Verrouiller), le retour à l'accueil ;
//   · à gauche : le formulaire (RegisterForm) ;
//   · à droite : le récapitulatif de commande — ce qui est inclus, le total
//     d'aujourd'hui (il suit la formule choisie), la garantie, la suite.
//
// Sur téléphone le récapitulatif passe SOUS le formulaire : le bouton reste
// dans le premier écran.
import { Link, useSearchParams } from 'react-router-dom'
import RegisterForm from '../components/urself/RegisterForm'
import { UBrand } from '../components/urself/Logo'
import { Check, Lock, Shield } from '../components/landing/Icons'
import { useT } from '../lib/i18n'
import Seo from '../components/Seo'

const PUB = process.env.PUBLIC_URL || ''

export default function Register () {
  const t = useT()
  const r = t.register
  const [params] = useSearchParams()
  const plan = params.get('plan') === 'yearly' ? 'yearly' : 'monthly'

  return (
    <>
      <Seo title={t.seo.register.title} description={t.seo.register.description} path="/register" />
      <div className="rg">
        <div className="rg__sky" aria-hidden="true" style={{ '--sky': `url(${PUB}/media/hero-sky.jpg)` }} />

        <header className="rg__top">
          <Link to="/" aria-label={t.nav.home}><UBrand /></Link>
          <ol className="rg__steps" aria-label="Progress">
            {r.steps.map((s, i) => (
              <li key={s} className={i === 0 ? 'is-on' : ''}>
                <i>{i + 1}</i><span>{s}</span>
              </li>
            ))}
          </ol>
          <span className="rg__login">{r.haveAccount} <Link to="/login">{r.loginLink}</Link></span>
        </header>

        <main className="rg__main">
          <section className="rg__form">
            <span className="rg__eyebrow">{r.eyebrow}</span>
            <h1 className="rg__h">{r.pageTitle}</h1>
            <p className="rg__sub">{r.pageSub}</p>
            <RegisterForm />
            <p className="rg__terms">
              {r.terms} <Link to="/cgv">{r.termsLink}</Link>.
            </p>
          </section>

          <aside className="rg__sum">
            <div className="rg__card">
              <div className="rg__cardhd">
                <span className="rg__cardt">{r.sumTitle}</span>
                <span className="rg__plan">{plan === 'yearly' ? r.yearly : r.monthly}</span>
              </div>

              <span className="rg__k">{r.sumIncl}</span>
              <ul className="rg__incl">
                {r.sumItems.map(x => <li key={x}><Check />{x}</li>)}
              </ul>

              <div className="rg__total">
                <span>{r.sumToday}</span>
                <b>{plan === 'yearly' ? r.yearlyPrice : r.monthlyPrice}</b>
              </div>
              <p className="rg__then">{r.sumThen(plan)}</p>

              <div className="rg__guar">
                <img src={`${PUB}/media/glass-lock.webp`} alt="" aria-hidden="true" width="720" height="720" />
                <span>
                  <b>{r.sumGuarT}</b>
                  {r.sumGuarP}
                </span>
              </div>
            </div>

            <div className="rg__next">
              <span className="rg__k">{r.nextT}</span>
              <ol>
                {r.next.map((x, i) => <li key={x}><i>{i + 1}</i>{x}</li>)}
              </ol>
            </div>

            <p className="rg__secure"><Lock />{r.secure}</p>
          </aside>
        </main>

        <footer className="rg__foot">
          <Shield /> <span>{t.footer.note(new Date().getFullYear())}</span>
        </footer>
      </div>
    </>
  )
}
